import { ActionNoticeDataBus, AsyncOperationEventDataBus, TransmissionDataBus } from './DataBus'

export function buildTransmissionDataBus() {
  return new TransmissionDataBus()
}

export function buildActionDataBus() {
  return new ActionNoticeDataBus()
}

export function buildAsyncOperationEventDataBus() {
  return new AsyncOperationEventDataBus()
}
